export const mockChatData2 = {
  "conversation-strategy": [
    {
      "id": 6,
	  "client_id": "Pertamina",
      "type": "answer",
      "title": "Conversation Strategist",
      "text": "Interactions Summarizer, can you please analyze previous client engagements to provide a summary of discussion points and action items?​",
      "data": {}
    },
    {
      "id": 7,
	  "client_id": "Pertamina",
      "type": "answer",
      "title": "Interactions Summarizer",
      "text": "Please see the insights in the middle pane",
      "data": {
        "meetings": [
          {
            "title": "Meeting with Pertamina on 15 January 2025",
            "participants": {
              "bank": [
                "John Smith (Relationship Manager)",
                "Sarah Lee (Credit Analyst)"
              ],
              "client": [
                "Emma Sri Martini (Director of Finance)",
                "Emily Davis (Treasury Head)"
              ]
            },
            "discussionTopics": [
              "Reviewed Company's financial performance for Q4 2024, highlighting revenue growth and cash flow trends.",
              "Discussed potential expansion plans and financing needs for increasing geothermal capacity in the next 5 years.",
              "Explored trade finance solutions to optimize working capital.",
              "Addressed a recent service issue related to payment delays in cross-border transactions."
            ],
            "actionItems": [
              {
                "title": "Investigate and resolve payment delay issue",
                "owner": "Relationship Manager",
                "dueDate": "January 17, 2025"
              },
              {
                "title": "Share Financing options for the expansion plans",
                "owner": "Relationship Manager",
                "dueDate": "January 22, 2025"
              }
            ]
          },
          {
            "title": "Meeting with Pertamina on February 24, 2025",
            "participants": {
              "bank": ["John Smith (Relationship Manager)"],
              "client": ["Emma Sri Martini (Director of Finance)"]
            },
            "discussionTopics": [
              "Reviewed existing credit facilities and upcoming loan maturities.",
              "Discussed renewal terms for the Term Loan Facility and potential revision in pricing."
            ],
            "actionItems": [
              {
                "title": "Follow-up on Overdue Payments of Term Loan",
                "owner": "Relationship Manager",
                "dueDate": "13 March 2025"
              },
              {
                "title": "Review Loan Renewal Terms for the Term Loan",
                "owner": "Relationship Manager",
                "dueDate": "05 March 2025"
              }
            ]
          }
        ],
      
      }
    },
    {
      "id": 8,
	  "client_id": "Pertamina",
      "type": "answer",
      "title": "Conversation Strategist",
      "text": "Conversation Guide, can you please recommend tailored discussion points for upcoming client meetings?",
      "data": {}
    },
    {
      "id": 9,
	  "client_id": "Pertamina",
      "type": "answer",
      "title": "Conversation Guide",
      "text": "Please see the conversation recommendations in the middle pane",
      "data": {
        "title": "Key Discussion Points for upcoming meetings",
        "discussionTopics": [
          {
            "topic": "Payment Issues",
            "points": [
              "Are there any internal or external challenges impacting your payment schedules?",
              "How can we support you in addressing these payment delays?",
              "Are there any upcoming payments that you foresee being at risk of delay?"
            ]
          },
          {
            "topic": "Term Loan Renewal Terms",
            "points": [
              "Reiterate the Term Loan Renewal terms which have been finalized.",
              "Discuss the next steps involved in renewal of the Term Loan Facility."
            ]
          },
          {
            "topic": "Actionable Steps",
            "points": [
              "Are there any immediate concerns or needs that we should address following this meeting?",
              "Can we schedule a follow-up meeting to review potential solutions and progress on current issues?"
            ]
          }
        ]
      }
    },
    {
      "id": 11,
	  "client_id": "Pertamina",
      "type": "answer",
      "title": "Conversation Strategist",
      "text": "The original query 'Analyze Client's Interactions with the Bank and recommend discussion points for the next meetings' has been completed. Please let me know if there is anything else that I can help you with.",
      "data": {}
    },
  ]
}

export const mockChatData3 = {
  "cro-overview": [
    {
      "id": 12,
	  "client_id": "Pertamina",
      "type": "answer",
      "title": "Bank Relationship Observer",
      "text": "Insights Generator, can you please provide provide insights around products availed by the client, relationship revenue, overdue compliances/payments and service requests etc.",
      "data": {}
    },  
    {
      "id": 13,
	  "client_id": "Pertamina",
      "type": "answer",
      "title": "Insights Generator",
      "text": "Please see the insights in the middle pane",
      "data": {
        "productsAndServices": {
          "loanAccountsOverview": {
            "totalCreditLimit": "85.00 Bn IDR",
            "totalUtilization": "94.4%",
            "totalCreditOutstanding": "80.20 Bn IDR"
          },
          "productBreakdown": [
            {
              "productName": "Term Loan",
              "productType": "Cash Loan",
              "creditLimit": "75.00 Bn IDR",
              "creditOutstanding": "70.20 Bn IDR",
              "utilization": "93.6%"
            },
            {
              "productName": "Working Capital",
              "productType": "Cash Loan",
              "creditLimit": "10.00 Bn IDR",
              "creditOutstanding": "10.00 Bn IDR",
              "utilization": "100%"
            }
          ],
          "liabilityAccountsOverview": {
            "totalLiabilities": "18.141.29 Bn IDR",
            "productBreakdown": [
              {
                "productName": "Current Account",
                "accountBalance": "6.000.00 Bn IDR"
              },
              {
                "productName": "Non-Individual Deposit Account",
                "accountBalance": "12.141.29 Bn IDR"
              }
            ]
          }
        },
        "relationshipRevenue": {
          "totalRevenueFY25": "16.47 Bn IDR",
          "revenueBreakdown": {
            "netInterestIncomeTarget": "18.29 Bn IDR",
            "netInterestIncomeActual": "16.33 Bn IDR",
            "feeCommissionIncomeTarget": "176.48 Mn IDR",
      			"feeCommissionIncomeActual": "134.93 Mn IDR"
          }
        },
        "serviceHistory": {
          "totalRequests": 11,
          "totalOpenRequests": 1,
          "totalResolvedRequests": 10,
          "mostFrequentRequests": ["Payment issues", "Document requests", "FX rate negotiations"],
          "resolutionEfficiency": "85% of cases resolved within 24 hours in last 3 months",
          "pendingRequests": "Term Loan Limit Renewal and enhancement request under review"
        },
		"recentServiceRequests": [
		{
		  "date": "15-02-2025",
		  "serviceType": "Transaction Enquiry",
		  "product": "Current Account",
		  "requestStatus": "Resolved",
		  "resolutionTime": "2 Hours"
		},
		{
		  "date": "10-02-2025",
		  "serviceType": "Limit Renewal and Enhancement",
		  "product": "Term Loan",
		  "requestStatus": "Pending",
		  "resolutionTime": "-"
		}
		],
		"overdueCompliancesPayments": {
		"totalOverdueCovenants": 2,
		"regulatoryCovenants": [
		  "Pertamina to provide KYC documentation",
		  "Pertamina to provide audited financials for Q4 FY 2024"
		],
		"overduePayments": "500 Mn IDR",
		"termLoanOverdue": "Overdue of 500 Mn IDR since last 20 days"
		},
  }
      },
      {
        "id": 14,
      "client_id": "Pertamina",
        "type": "answer",
        "title": "Bank Relationship Observer",
        "text": "Bank Relationship Summarizer, can you please summarize the insights provided by the Insights Generator?",
        "data": {}
      },
      {
        "id": 15,
      "client_id": "Pertamina",
        "type": "answer",
        "title": "Bank Relationship Summarizer",
        "text": "Please see the summary info in the middle pane",
        "data": {
      "summary": {
          "clientInteractionSummary": "Pertamina had 2 interactions with the Bank in the last 2 months on recent financial performance, key metrics, Company’s potential expansion plans and renewal terms of Term Loan facility.",
        "loanExposure": "80.20 Bn IDR (Term Loan Facility and Working Capital Facility)",
        "termLoanUtilization": "70.20 Bn IDR",
        "workingCapitalUtilization": "10.00 Bn IDR",
        "totalLiabilities": "18.141.29 Bn IDR (Current Account and Non-Individual Deposit Account)",
        "totalRevenueFY25": "16.47 Bn IDR",
        "serviceHistorySummary": "Pertamina has actively engaged with the bank for various service requests, including transaction inquiries, payment issues, and limit enhancements. 85% of service requests in the last 3 months have been resolved within 24 hours, with frequent inquiries around payments and FX rates. Term Loan Limit Renewal and enhancement is under review."
      }
    }
        },
        {
          "id": 16,
        "client_id": "Pertamina",
          "type": "answer",
          "title": "Business Relationship Observer",
          "text": "The original query 'Generate an overview of Client's Relationship and Interactions with the Bank' has been completed. Please let me know if there is anything else that I can help you with.",
          "data": {}
        },
]
}

export const mockChatData4 = {
  "company-research": [
    {
      "id": 6,
	  "client_id": "Pertamina",
      "type": "answer",
      "title": "Company Scanner",
      "text": "Strategic visionary, can you please analyze company data to provide insights around company's focus areas, early warning signals and opportunities for the company?",
      "data": {}
    },
    {
    "id": 7,
    "client_id": "Pertamina",
    "type": "answer",
    "title": "Strategic Visionary",
    "text": "Please see the information on company's short-term and long-term focus areas, EWS and Opportunities in the middle pane",
    "data": {
      strategicVision: { "title": "Strategic Vision of the Company",
        "section": "Focus Area",
        "section_data": [
        {
          "title": "Pertamina Renewable Energy",
          "content": "Pertamina's key growth sector is renewable energy, with a focus on geothermal energy, and the company aims to increase its geothermal capacity to 1,272 MW in the next 5 years."
        },
        {
          "title": "Sustainability Commitment",
          "content": "The company has a strong commitment to sustainability, with a goal to achieve Net Zero Emissions by 2060, and has developed several strategies to reduce its carbon footprint, including the development of green refineries and biofuels."
        },
        {
          "title": "Pertamina Partnerships",
          "content": "Pertamina has formed notable partnerships, including a joint study agreement with Chevron New Energies International Pte. Ltd. to evaluate the feasibility of carbon capture storage and carbon capture, utilization, and storage (CCS/CCUS) in East Kalimantan, Indonesia."
        },
        {
          "title": "Expansion Projects",
          "content": "The company has planned projects to expand its refining and petrochemical capacity, including the development of a new green refinery in Plaju and the revamp of the TPPI olefin plant."
        },
        {
          "title": "Digitalization Initiatives",
          "content": "Pertamina is also focusing on strategic initiatives to improve its business growth, including the implementation of digitalization and innovation, with a target to increase its digitalization level to 80% by 2025."
        }
      ]},
     earlyWarnings: {
      "title": "", 
      "section": "Early Warning Signals And Opportunities",
      "section_data": [
        {
          "signal": "Revenue Decline",
          "description": "Pertamina's revenue decreased by 11% due to lower oil prices and the weakening IDR currency rate, from $84.89 billion to $75.79 billion."
        },
        {
          "signal": "Regulatory Risks",
          "description": "The company faces regulatory risks, including potential changes in government policies and subsidies, which could impact its financial performance, with a potential cost increase of $8.69 billion."
        },
        {
          "signal": "Positive Impact of External Factors",
          "description": "The company's EBITDA increased by 6% from $13.59 billion to $14.36 billion, driven by external factors such as government support."
        },
        {
          "signal": "Involvement in Large-Scale Projects",
          "description": "Pertamina is involved in large-scale projects, including the development of renewable energy and infrastructure projects, with a potential estimated financial value of $67 billion."
        }
      ]
     }

  },  
},
{
  "id": 8,
"client_id": "Pertamina",
  "type": "answer",
  "title": "Company Scanner",
  "text": "Company News Tracker, can you please provide an overview of the recent news pertaining to the Company?",
  "data": {}
},
{
"id": 9,
"client_id": "Pertamina",
"type": "answer",
"title": "Company News Tracker",
"text": "Please see the overview of the recent news pertaining to Company in the middle pane",
"data": {
  "newsTracking": [
    {
      "title": "Pertamina Achieves ESG Milestone",
      "content": "Pertamina NRE has achieved a significant milestone by receiving the 3rd best ESG rating in the world with a score of 13.0 and a 'Low Risk Category' designation from Sustainalytics.",
      "date": "September 13, 2023"
    },
    {
      "title": "Pertamina Commits to ESG",
      "content": "This achievement demonstrates the company's commitment to implementing ESG aspects in its operations. The rating positions Pertamina NRE as a leader in the Independent Power Producer & Trader sector. Pertamina's subsidiary, PT Pertamina Geothermal Energy Tbk, has signed a joint study agreement with Guma Africa Group to cooperate on a natural gas and power project in South Africa.",
      "date": "September 3, 2024"
    },
    {
      "title": "Pertamina Expands Global Business",
      "content": "The agreement aims to study the potential development of a gas-to-power project, as Pertamina NRE seeks to expand its global businesses. This partnership is a strategic step for Pertamina to strengthen its position in the global energy market. Pertamina has initiated a pre-marketing program in Bali, supplying Sustainable Aviation Fuel (SAF) to several airlines, with the goal of reducing emissions by up to 84%.",
      "date": "No specific date available"
    },
    {
      "title": "Pertamina Reduces Emissions",
      "content": "The company aims to increase Used Cooking Oil (UCO) collection from 0.3 million tons in 2023 to 1.5 million tons by 2030 to support SAF production. This effort is part of Pertamina's commitment to driving sustainable energy transitions in the aviation sector. PT Pertamina Hulu Energi has recorded a significant increase in production, reaching 1 million barrels of oil equivalent per day (BOEPD) after two years as Pertamina's Upstream Subholding.",
      "date": "September 11, 2023"
    },
    {
      "title": "Pertamina Increases Production",
      "content": "The company has implemented various strategies to increase production, including adding a 10% participating interest in Iraq and acquiring working areas in East Natuna, Bunga, and Peri Mahakam. This achievement demonstrates Pertamina's commitment to increasing its oil and gas production. Pertamina New Renewable Energy has signed an agreement with Chevron New Energies International Pte. Ltd. to evaluate the feasibility of carbon capture storage and carbon capture, utilization, and storage (CCS/CCUS) in East Kalimantan, Indonesia.",
      "date": "No specific date available"
    },
    {
      "title": "Pertamina Signs LNG Agreement",
      "content": "The agreement is expected to strengthen the energy cooperation between the two countries, with Pertamina supplying LNG to the Philippines. This deal is a significant development for Pertamina, as it expands its presence in the global energy market and strengthens its position as a leading energy company in the region.",
      "date": "No specific date available"
    }
  ],
},

},
{
  "id": 10,
"client_id": "Pertamina",
  "type": "answer",
  "title": "Company Scanner",
  "text": "Company Research Summarizer, can you please summarize the insights provided by the Strategic Vision Extractor and Company News Tracker",
  "data": {}
},
{
"id": 11,
"client_id": "Pertamina",
"type": "answer",
"title": "Company Research Summarizer",
"text": "Please see the summary in the middle pane",
"data": {
  "summary": {
    "strategicVisionSummary": "Pertamina Renewable Energy is committed to expanding its geothermal capacity to 1,272 MW within the next five years while striving for Net Zero Emissions by 2060 through green refineries and biofuels. The company has formed key partnerships, including a joint study with Chevron on carbon capture initiatives, and is investing in refining and petrochemical expansion projects. Additionally, Pertamina aims to enhance business growth through digitalization, targeting 80% adoption by 2025.",
    "newsTrackingSummary": "Pertamina Renewable Energy continues to strengthen its global presence with key sustainability and expansion initiatives. It achieved the 3rd best ESG rating globally, reinforcing its commitment to sustainable practices. The company is expanding its business through partnerships, including a gas-to-power project in South Africa and LNG supply to the Philippines. Additionally, Pertamina is scaling up Used Cooking Oil collection to support Sustainable Aviation Fuel production and increasing oil and gas output through strategic acquisitions. These efforts position Pertamina as a leader in renewable energy, emissions reduction, and global energy cooperation."
  }
},

},
{
  "id": 12,
"client_id": "Pertamina",
  "type": "answer",
  "title": "Company Scanner",
  "text": "The original query 'Generate a Summary of Company's focus areas, EWS & Opportunities and latest Company news has been completed. Please let me know if there is anything else that I can help you with.",
  "data": {}
},
]
}

